/** Canonical backend region code for the national timber-price aggregate. */
export const NATIONAL_REGION_CODE = "NATIONAL";
